import { FishingReport, WaterbodyDetail } from '@omniafishing/core';
import { Dayjs } from 'dayjs';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { WaterbodyActions } from '../../redux/waterbody';
import { Waterbody_Detail } from './waterbody_detail';

interface WaterbodyDetailContainerProps {
  fishingReports: FishingReport[];
  fishingReportsNearby: FishingReport[];
  mostRecentFishingReportDate: Dayjs;
  sortedFishingReports: FishingReport[];
  totalFishingReportsCount: number;
  waterbodyDetail: WaterbodyDetail;
}

export const WaterbodyDetailContainer = (props: WaterbodyDetailContainerProps) => {
  const {
    fishingReports,
    fishingReportsNearby,
    mostRecentFishingReportDate,
    sortedFishingReports,
    totalFishingReportsCount,
    waterbodyDetail,
  } = props;

  const dispatch = useDispatch();

  useEffect(() => {
    return () => {
      dispatch(WaterbodyActions.WATERBODY_RESET());
    };
  }, []);

  if (!waterbodyDetail) {
    return null;
  }

  return (
    <Waterbody_Detail
      fishingReports={fishingReports}
      fishingReportsNearby={fishingReportsNearby}
      mostRecentFishingReportDate={mostRecentFishingReportDate}
      sortedFishingReports={sortedFishingReports}
      totalFishingReportsCount={totalFishingReportsCount}
      waterbody={waterbodyDetail}
    />
  );
};
